var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[_c('Container',[(_vm.previewUrl)?_c('XImage',{attrs:{"width":"100%","src":("" + _vm.previewUrl)}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }